import { Injectable } from "@angular/core";
import { Media } from "src/app/models/media";
import { MediaClass } from "src/app/models/media-class";

@Injectable()
export class MediaService {
  getSignature(media: {
    mediaClass: { sign: string };
    author: string;
    publisher: string;
  }) {
    return `${
      media.mediaClass ? media.mediaClass.sign : ""
    }-${this.getAuthorSignature(media)}`;
  }

  getAuthorSignature(media: { author: string; publisher: string }) {
    if (!media) return "";

    const isAbbreviation = (token: string) => token.endsWith(".");
    const toSignature = (name: string) =>
      name
        .replace(/^(de|von|van) /i, "")
        .slice(0, 4)
        .toUpperCase();

    const author = media.author?.replace(/[()]/g, "").trim();
    if (!author) {
      return (media.publisher ?? "").slice(0, 4).toUpperCase();
    }

    let name: string;

    if (author.includes(",")) {
      const beforeComma = author.split(",")[0].trim();

      if (/.+ .+,.+/.test(author)) {
        // Original behaviour: if the name starts with an initial, drop all
        // initials; otherwise keep every token as-is.
        const tokens = beforeComma.split(/\s+/);
        name = (
          isAbbreviation(tokens[0])
            ? tokens.filter((t) => !isAbbreviation(t))
            : tokens
        ).join(" ");
      } else {
        name = beforeComma; // "Surname, Given"
      }
    } else {
      // "Given Surname": skip the first token, drop initials
      const tokens = author.split(/\s+/);
      name =
        tokens.length > 1
          ? tokens
              .slice(1)
              .filter((t) => !isAbbreviation(t))
              .join(" ")
          : tokens[0];
    }

    return toSignature(name);
  }
}
